import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react'
import React from 'react'
import type { ReactElement } from 'react'
import DatePicker from 'react-datepicker'
import { isNull } from 'lodash'
import DateCustomInput from '../../../DateCustomInput'
import type { CMFieldProps } from '.'
import 'react-datepicker/dist/react-datepicker.css'

const CMDateField = ({
  cmField,
  disabled,
  isUpload,
  form,
}: CMFieldProps): ReactElement => (
  <FormControl
    marginBottom={isUpload ? 0 : '30px'}
    isInvalid={Boolean(
      form.errors?.upload &&
        form.touched?.upload &&
        form.errors?.upload[cmField.name] &&
        form.touched?.upload[cmField.name],
    )}
    isRequired={cmField.schema.isValueRequired}
    isDisabled={disabled}
  >
    <FormLabel>{cmField.label}</FormLabel>
    <DatePicker
      disabled={disabled}
      readOnly={disabled}
      selected={
        form?.values?.upload[cmField.name]
          ? new Date(form?.values?.upload[cmField.name])
          : undefined
      }
      isClearable
      customInput={React.createElement(React.forwardRef(DateCustomInput))}
      onChange={(newDate: Date | null) => {
        if (isNull(newDate)) {
          form.setFieldValue(`upload.['${cmField.name}']`, null)
        } else {
          form.setFieldValue(`upload.['${cmField.name}']`, newDate.toISOString())
        }
      }}
    />
    <FormErrorMessage>
      {form.errors?.upload && form.errors?.upload[cmField.name]}
    </FormErrorMessage>
  </FormControl>
)

export default CMDateField
